export default "__VITE_ASSET__BNO7T2DS__"